import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { BaseMortgageApplicationComponent } from '../base-mortgage-application.component';
import { MortgageApplicationStore } from './../../services/mortgage-application-store';

@Component({
  selector: 'boi-your-property',
  templateUrl: './your-property.page.html',
  styleUrls: ['./your-property.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class YourPropertyPage extends BaseMortgageApplicationComponent {
  constructor(
    protected mortgageApplicationStore: MortgageApplicationStore,
    public changeDetectorRef: ChangeDetectorRef
  ) {
    super(mortgageApplicationStore);
  }

  public submitUnregisteredFactFind(): void {
    this.mortgageApplicationStore.notifySubmitUnregisteredFactFind();
  }
}
